"use client"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs" 
import { BadgeReportList } from "./badge-report-list"

export function BadgeReportContainer() {
  return (
    <>
      <Breadcrumbs mainTitle="Badge Reports" parent="Reports" />
      <Container fluid>
        <Row>
          <Col md="12">
            <BadgeReportList />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default BadgeReportContainer
